import { render, staticRenderFns } from "./NearModel.vue?vue&type=template&id=1b97bd9b&scoped=true&"
import script from "./NearModel.vue?vue&type=script&lang=js&"
export * from "./NearModel.vue?vue&type=script&lang=js&"
import style0 from "./NearModel.vue?vue&type=style&index=0&id=1b97bd9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97bd9b",
  null
  
)

export default component.exports